import { bootstrapApplication } from '@angular/platform-browser';
import './app/Extensions/date-extension';
import * as Sentry from '@sentry/angular';
import { environment } from 'environments/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { disableSanitizingHTMLWarning } from 'app/Utils/disable-sanitizer-warning.function';

Sentry.init({
  dsn: 'https://4d1544de11d130d78c0791e4536238a5@o4508042081337344.ingest.de.sentry.io/4508766023123024',
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  environment: environment.envType,
  ignoreErrors: [
      /Http failure response.*0 Unknown Error/
  ]
});

disableSanitizingHTMLWarning();
bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
